import Vue from 'vue';
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import ABaseComponent from "Components/Base/ABaseComponent";
import * as Cookies from 'es-cookie';
import "jquery";
import "select2";

@Component({})
export default class ImpersonationSelectComponent extends ABaseComponent{
    @Prop()
    defaultCompanyId:string;
    
    public selectedLocation:string = "";
    public postSelected: string = "";

    public loadingCompany: boolean = false;
    public loadingLocation: boolean = false;

    created() {
        this.setLoaded();
    }
    mounted() {
        const target = $(document.getElementById("location-select"));
        const self = this;

        target.select2();

        target.on("change", function(){
            self.selectedLocation = $(this).find("option:selected").val().toString();
            self.postSelected = self.removeTypeFromCustomerId(self.selectedLocation);
        });

        self.selectedLocation = target.find("option:first-child").val().toString();
    }
    get showManagementModeButton() {
        return this.selectedLocation.includes("M:");
    }
    impersonateLocation(){
        this.loadingLocation = true;
        Cookies.set("IsManagementModeActive", "false");
    }
    impersonateCompany(){
        this.loadingCompany = true;
        Cookies.set("IsManagementModeActive", "true");
    }
    removeTypeFromCustomerId(customerId: string) {
        return customerId.substring(2);
    }
}
Vue.component("impersonation-select",ImpersonationSelectComponent)